import React, { createContext, useContext, useState, useEffect } from 'react';
import chartDataService from '../services/chartDataService';

const ChartDataContext = createContext();

export const useChartData = () => {
  const context = useContext(ChartDataContext);
  if (!context) {
    throw new Error('useChartData must be used within a ChartDataProvider');
  }
  return context;
};

export const ChartDataProvider = ({ children }) => {
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isDataFetched, setIsDataFetched] = useState(false);

  // NO CACHE ON MOUNT - always start fresh
  useEffect(() => {
    console.log('ChartDataContext initialized - cache disabled, always fetch fresh');
    // Clear any old cache data
    chartDataService.clearCache();
  }, []);

  // Fetch chart data - always fresh, never use cached
  const fetchChartData = async () => {
    console.log('🔄 Fetching FRESH chart data from API...');
    
    setLoading(true);
    setError(null);
    
    try {
      const data = await chartDataService.getChartData();
      setChartData(data);
      setIsDataFetched(true);
      console.log('✅ Fresh chart data loaded successfully:', data);
      return data;
    } catch (err) {
      setError(err.message);
      console.error('❌ Failed to fetch chart data:', err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  // Clear chart data
  const clearChartData = () => {
    setChartData(null);
    setIsDataFetched(false);
    setError(null);
    chartDataService.clearCache();
  };

  // Check if data is cached
  const hasCachedData = () => {
    return chartDataService.hasCachedData();
  };

  const value = {
    chartData,
    loading,
    error,
    isDataFetched,
    fetchChartData,
    clearChartData,
    hasCachedData
  };

  return (
    <ChartDataContext.Provider value={value}>
      {children}
    </ChartDataContext.Provider>
  );
}; 